import { Component, OnInit, ViewChild } from '@angular/core';
import { CNReport } from 'src/app/models/cnreport';
import { ReportService } from 'src/app/services/report.service';
import { ReportTableComponent } from '../report-table/report-table.component';

@Component({
  selector: 'app-report-widget',
  templateUrl: './report-widget.component.html',
  styleUrls: ['./report-widget.component.scss']
})
export class ReportWidgetComponent implements OnInit {

  public reports: CNReport[] = [];
  @ViewChild('reporttable', { static: true }) reportTable: ReportTableComponent;

  constructor(private reportservice: ReportService) { }

  ngOnInit(): void {
    this.reportservice.data.subscribe(data => {
      this.reports = data;
    });
    this.reportservice.clear.subscribe(flag => {
      this.reports = [];
      this.reportTable.clear();
    });
  }
}
